function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.9592 2.79068C20.8612 2.69347 20.7022 2.69347 20.6041 2.79068L8.76842 14.5252L3.37316 9.17606C3.27511 9.07885 3.11614 9.07885 3.01809 9.17606L0.177541 11.9923C0.0794915 12.0895 0.0794916 12.2471 0.177541 12.3444L8.5818 20.6767C8.63057 20.7251 8.6944 20.7494 8.75832 20.7496C8.82859 20.7548 8.90062 20.7307 8.95436 20.6774L23.7998 5.95897C23.8978 5.86176 23.8978 5.70415 23.7998 5.60694L20.9592 2.79068Z",
  fill: "#09B790"
})));